import Vue from 'vue'
import { createHelpers } from 'vuex-map-fields'
import _ from 'lodash'

import router from '@/router'

import {
  // CREATE_FAMILY_QUOTATION
  CREATE_FAMILY_QUOTATION_REQUEST,
  CREATE_FAMILY_QUOTATION_SUCCESS,
  CREATE_FAMILY_QUOTATION_FAILURE,

  // GET_FAMILY_INFORMATION
  GET_FAMILY_INFORMATION_REQUEST,
  GET_FAMILY_INFORMATION_SUCCESS,
  GET_FAMILY_INFORMATION_FAILURE,

  // GET_FAMILY_PAYER
  GET_FAMILY_PAYER_REQUEST,
  GET_FAMILY_PAYER_SUCCESS,
  GET_FAMILY_PAYER_FAILURE,

  // GET_FAMILY_RELATIONSHIP
  GET_FAMILY_RELATIONSHIP_REQUEST,
  GET_FAMILY_RELATIONSHIP_SUCCESS,
  GET_FAMILY_RELATIONSHIP_FAILURE,

  // GET_BENEFICIARY_RELATIONSHIP
  GET_BENEFICIARY_RELATIONSHIP_REQUEST,
  GET_BENEFICIARY_RELATIONSHIP_SUCCESS,
  GET_BENEFICIARY_RELATIONSHIP_FAILURE,

  // UPDATE_FAMILY_RELATIONSHIP
  UPDATE_FAMILY_RELATIONSHIP_REQUEST,
  UPDATE_FAMILY_RELATIONSHIP_SUCCESS,
  UPDATE_FAMILY_RELATIONSHIP_FAILURE,
} from '@/lib/mutationTypes'
import API, { HOMEPAGE_URL } from '@/lib/api'
import { generateAuthorizationRequestHeader } from '@/lib/services'

const conf = require('../../config/index.js')
const env = process.env.NODE_ENV || 'alpha'

const { getFamilyFields, updateFamilyFields } = createHelpers({
  getterType: 'getFamilyFields',
  mutationType: 'updateFamilyFields',
})

const state = {
  familyInformation: {
    data: null,
    isLoading: false,
    isError: false,
  },
  familyPayer: {
    data: [],
    isLoading: false,
    isError: false,
  },
  familyRelationship: {
    data: [],
    isLoading: false,
    isError: false,
  },
  beneficiaryRelationship: {
    data: [],
    isLoading: false,
    isError: false,
  },
  relationship: {
    relations1: null,
    relations2: null,
    relations3: null,
    relations4: null,
    relations5: null,
    relations6: null,
  },
  rules: {
    relations1: '',
    relations2: '',
    relations3: '',
    relations4: '',
    relations5: '',
    relations6: '',
  },
  create_family: null,
  type_family: null,
  update_qt_family: null,
  get_family: null,
  update_relation: null,
  select_relation: null,
  list_payer: null,
  update_family_payer: null,
  update_family_main_payer: null,
  check_payment_family: null,
  isOffsideSaleFamilyQuotation: false,
}

const mutations = {
  // CREATE_FAMILY_QUOTATION
  [CREATE_FAMILY_QUOTATION_REQUEST](state) {
    state.familyInformation.isLoading = true
    state.familyInformation.isError = false
  },
  [CREATE_FAMILY_QUOTATION_SUCCESS](state) {
    state.familyInformation.isLoading = false
    state.familyInformation.isError = false
  },
  [CREATE_FAMILY_QUOTATION_FAILURE](state) {
    state.familyInformation.isLoading = false
    state.familyInformation.isError = true
  },

  // GET_FAMILY_INFORMATION
  [GET_FAMILY_INFORMATION_REQUEST](state) {
    state.familyInformation.isLoading = true
    state.familyInformation.isError = false
  },
  [GET_FAMILY_INFORMATION_SUCCESS](state, payload) {
    state.familyInformation.data = _.cloneDeep(payload)
    state.familyInformation.isLoading = false
    state.familyInformation.isError = false

    _.chain(payload)
      .get('quotationInfo', [])
      .head()
      .get('familyQuotation.quotations', [])
      .value()
      .forEach((quotation, idx) => {
        state.relationship[`relations${idx + 1}`] = quotation.relationshipId

        state.rules[`relations${idx + 1}`] = 'required'
      })
  },
  [GET_FAMILY_INFORMATION_FAILURE](state) {
    state.familyInformation.isLoading = false
    state.familyInformation.isError = true
  },

  // GET_FAMILY_PAYER
  [GET_FAMILY_PAYER_REQUEST](state) {
    state.familyPayer.isLoading = true
    state.familyPayer.isError = false
  },
  [GET_FAMILY_PAYER_SUCCESS](state, payload) {
    state.familyPayer.data = _.cloneDeep(payload)
    state.familyPayer.isLoading = false
    state.familyPayer.isError = false
  },
  [GET_FAMILY_PAYER_FAILURE](state) {
    state.familyPayer.isLoading = false
    state.familyPayer.isError = true
  },

  // GET_FAMILY_RELATIONSHIP
  [GET_FAMILY_RELATIONSHIP_REQUEST](state) {
    state.familyRelationship.isLoading = true
    state.familyRelationship.isError = false
  },
  [GET_FAMILY_RELATIONSHIP_SUCCESS](state, payload) {
    state.familyRelationship.data = _.cloneDeep(payload)
    state.familyRelationship.isLoading = false
    state.familyRelationship.isError = false
  },
  [GET_FAMILY_RELATIONSHIP_FAILURE](state) {
    state.familyRelationship.isLoading = false
    state.familyRelationship.isError = true
  },

  // GET_BENEFICIARY_RELATIONSHIP
  [GET_BENEFICIARY_RELATIONSHIP_REQUEST](state) {
    state.beneficiaryRelationship.isLoading = true
    state.beneficiaryRelationship.isError = false
  },
  [GET_BENEFICIARY_RELATIONSHIP_SUCCESS](state, payload) {
    state.beneficiaryRelationship.data = _.cloneDeep(payload)
    state.beneficiaryRelationship.isLoading = false
    state.beneficiaryRelationship.isError = false
  },
  [GET_BENEFICIARY_RELATIONSHIP_FAILURE](state) {
    state.beneficiaryRelationship.isLoading = false
    state.beneficiaryRelationship.isError = true
  },

  // UPDATE_FAMILY_RELATIONSHIP
  [UPDATE_FAMILY_RELATIONSHIP_REQUEST](state) {
    state.familyInformation.isLoading = true
    state.familyInformation.isError = false
  },
  [UPDATE_FAMILY_RELATIONSHIP_SUCCESS](state) {
    state.familyInformation.isLoading = false
    state.familyInformation.isError = false
  },
  [UPDATE_FAMILY_RELATIONSHIP_FAILURE](state) {
    state.familyInformation.isLoading = false
    state.familyInformation.isError = true
  },
  CREATE_FAMILY(state, payload) {
    state.create_family = payload
  },
  UPDATE_QT_FAMILY(state, payload) {
    state.update_qt_family = payload
  },
  GET_FAMILY(state, payload) {
    state.get_family = payload
  },
  UPDATE_RERATION_FAMILY(state, payload) {
    state.update_relation = payload
  },
  CHECK_SELECT_RERATION(state, payload) {
    state.select_relation = payload
  },
  GET_PAY_FAMILY(state, payload) {
    state.list_payer = payload
  },
  UPDATE_FAMILY_QT_PAYER(state, payload) {
    state.update_family_payer = payload
  },
  UPDATE_FAMILY_MAIN_PAYER(state, payload) {
    state.update_family_main_payer = payload
  },
  CHECK_PAYMENT_FAMILY(state, payload) {
    state.check_payment_family = payload
  },
  updateFamilyFields,
  IS_OFFSIDE_SALE_FAMILY_QUOTATION: function (state, isOffsideSale) {
    state.isOffsideSaleFamilyQuotation = isOffsideSale
  }
}

const actions = {
  createFamilyQuotation({ commit }, familyType) {
    commit(CREATE_FAMILY_QUOTATION_REQUEST)

    Vue.http
      .put(
        API.FAMILY.CREATE_FAMILY_QUOTATION,
        { familyDiscountId: familyType },
        {
          headers: {
            ...generateAuthorizationRequestHeader(),
          },
        },
      )
      .then(res => res.json())
      .then(
        response => {
          commit(CREATE_FAMILY_QUOTATION_SUCCESS)

          router.push(`/insurance_family/${response.result.familyId}`)
        },
        error => {
          const { status } = error

          if (status === 401) {
            this._vm.$session.destroy()

            window.location.href = HOMEPAGE_URL
          }

          if (status === 403) {
            this._vm.$swal({
              type: 'error',
              title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
            })
          }

          if (status === 400) {
            commit(CREATE_FAMILY_QUOTATION_FAILURE)

            this.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดในการสร้าง Family',
            })
          }

          if (status === 500) {
            commit(CREATE_FAMILY_QUOTATION_FAILURE)

            this.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดในการสร้าง Family',
            })
          }
        },
      )
  },
  getFamilyInformation({ commit }, familyId) {
    commit(GET_FAMILY_INFORMATION_REQUEST)

    Vue.http
      .get(API.FAMILY.GET_FAMILY_INFORMATION(familyId), {
        headers: {
          ...generateAuthorizationRequestHeader(),
        },
      })
      .then(res => res.json())
      .then(
        response => commit(GET_FAMILY_INFORMATION_SUCCESS, response.result),
        error => {
          const { status } = error

          if (status === 401) {
            this._vm.$session.destroy()

            window.location.href = HOMEPAGE_URL
          }

          if (status === 403) {
            this._vm.$swal({
              type: 'error',
              title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
            })
          }

          if (status === 400) {
            commit(GET_FAMILY_INFORMATION_FAILURE)
          }

          if (status === 500) {
            commit(GET_FAMILY_INFORMATION_FAILURE)
          }
        },
      )
  },
  getFamilyPayerInformation({ commit }, familyId) {
    commit(GET_FAMILY_PAYER_REQUEST)

    Vue.http
      .get(API.FAMILY.GET_FAMILY_PAYER(familyId), {
        headers: {
          ...generateAuthorizationRequestHeader(),
        },
      })
      .then(res => res.json())
      .then(
        response => commit(GET_FAMILY_PAYER_SUCCESS, response.result),
        error => {
          const { status } = error

          if (status === 401) {
            this._vm.$session.destroy()

            window.location.href = HOMEPAGE_URL
          }

          if (status === 403) {
            this._vm.$swal({
              type: 'error',
              title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
            })
          }

          if (status === 400) {
            commit(GET_FAMILY_PAYER_FAILURE)
          }

          if (status === 500) {
            commit(GET_FAMILY_PAYER_FAILURE)
          }
        },
      )
  },
  getFamilyRelationship({ commit }) {
    commit(GET_FAMILY_RELATIONSHIP_REQUEST)

    Vue.http
      .get(API.GENERAL.FAMILY_RELATIONSHIP, {
        headers: {
          ...generateAuthorizationRequestHeader(),
        },
      })
      .then(res => res.json())
      .then(
        response => commit(GET_FAMILY_RELATIONSHIP_SUCCESS, response.result.relationship),
        error => {
          const { status } = error

          if (status === 401) {
            this._vm.$session.destroy()

            window.location.href = HOMEPAGE_URL
          }

          if (status === 403) {
            this._vm.$swal({
              type: 'error',
              title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
            })
          }

          if (status === 400) {
            commit(GET_FAMILY_RELATIONSHIP_FAILURE)
          }

          if (status === 500) {
            commit(GET_FAMILY_RELATIONSHIP_FAILURE)
          }
        },
      )
  },
  getBeneficiaryRelationship({ commit }) {
    commit(GET_BENEFICIARY_RELATIONSHIP_REQUEST)

    Vue.http
      .get(API.GENERAL.BENEFICIARY_RELATIONSHIP, {
        headers: {
          ...generateAuthorizationRequestHeader(),
        },
      })
      .then(res => res.json())
      .then(
        response => commit(GET_BENEFICIARY_RELATIONSHIP_SUCCESS, response.result.relationship),
        error => {
          const { status } = error

          if (status === 401) {
            this._vm.$session.destroy()

            window.location.href = HOMEPAGE_URL
          }

          if (status === 403) {
            this._vm.$swal({
              type: 'error',
              title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
            })
          }

          if (status === 400) {
            commit(GET_BENEFICIARY_RELATIONSHIP_FAILURE)
          }

          if (status === 500) {
            commit(GET_BENEFICIARY_RELATIONSHIP_FAILURE)
          }
        },
      )
  },
  updateFamilyRelationship({ commit, state }, quotationIndex) {
    commit(UPDATE_FAMILY_RELATIONSHIP_REQUEST)

    const familyDiscount = _.get(state, 'familyInformation.data.familyInfo.discount', 0)
    const familyRelationship = _.get(state, `relationship.relations${quotationIndex}`, 0)
    const quotationId = _.get(
      state,
      `familyInformation.data.quotationInfo[${quotationIndex - 1}].quotation.quotationId`,
      '',
    )

    Vue.http
      .post(
        API.FAMILY.UPDATE_FAMILY_RELATIONSHIP(quotationId),
        {
          quotationInfo: {
            discount: familyDiscount,
            family_relationship: familyRelationship,
          },
        },
        {
          headers: {
            ...generateAuthorizationRequestHeader(),
          },
        },
      )
      .then(res => res.json())
      .then(
        response => commit(UPDATE_FAMILY_RELATIONSHIP_SUCCESS),
        error => {
          const { status } = error

          if (status === 401) {
            this._vm.$session.destroy()

            window.location.href = HOMEPAGE_URL
          }

          if (status === 403) {
            this._vm.$swal({
              type: 'error',
              title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
            })
          }

          if (status === 400) {
            commit(UPDATE_FAMILY_RELATIONSHIP_FAILURE)
          }

          if (status === 500) {
            commit(UPDATE_FAMILY_RELATIONSHIP_FAILURE)
          }
        },
      )
  },

  setCheckRelations({ commit }, data) {
    commit('CHECK_SELECT_RERATION', data)
  },
  setCheckPaymentFamily({ commit }, data) {
    commit('CHECK_PAYMENT_FAMILY', data)
  },

  api_update_family_quotation({ commit }, data) {
    //console.log('**update family**', data)
    let dataRm = {
      rm_id: typeof data.rm_id == 'undefined' ? null : data.rm_id,
      card_id: typeof data.card_id == 'undefined' ? null : data.card_id,
      passport_id: typeof data.passport_id == 'undefined' ? null : data.passport_id,
      company_id: typeof data.company_id == 'undefined' ? null : data.company_id,
      rm_title_name: typeof data.rm_title_name == 'undefined' ? null : data.rm_title_name,
      first_name: typeof data.first_name == 'undefined' ? null : data.first_name,
      last_name: typeof data.last_name == 'undefined' ? null : data.last_name,
      sex: typeof data.sex == 'undefined' ? null : data.sex,
      birth_date: typeof data.birth_date == 'undefined' ? null : data.birthDay.human.origin,
      rm_occp_name: typeof data.rm_occp_name == 'undefined' ? null : data.rm_occp_name,
      card_address1: typeof data.card_address1 == 'undefined' ? null : data.card_address1,
      card_address2: typeof data.card_address2 == 'undefined' ? null : data.card_address2,
      card_address3: typeof data.card_address3 == 'undefined' ? null : data.card_address3,
      card_address4: typeof data.card_address4 == 'undefined' ? null : data.card_address4,
      card_city: typeof data.card_city == 'undefined' ? null : data.card_city,
      card_postcode: typeof data.card_postcode == 'undefined' ? null : data.card_postcode,
      card_country: typeof data.card_country == 'undefined' ? null : data.card_country,
      card_telephone: typeof data.card_telephone == 'undefined' ? null : data.card_telephone,
      card_mobile: typeof data.card_mobile == 'undefined' ? null : data.card_mobile,
      contact_address1: typeof data.contact_address1 == 'undefined' ? null : data.contact_address1,
      contact_address2: typeof data.contact_address2 == 'undefined' ? null : data.contact_address2,
      contact_address3: typeof data.contact_address3 == 'undefined' ? null : data.contact_address3,
      contact_address4: typeof data.contact_address4 == 'undefined' ? null : data.contact_address4,
      contact_city: typeof data.contact_city == 'undefined' ? null : data.contact_city,
      contact_postcode: typeof data.contact_postcode == 'undefined' ? null : data.contact_postcode,
      contact_country: typeof data.contact_country == 'undefined' ? null : data.contact_country,
      contact_telephone:
        typeof data.contact_telephone == 'undefined' ? null : data.contact_telephone,
      contact_mobile: typeof data.contact_mobile == 'undefined' ? null : data.contact_mobile,

      saving_name: typeof data.saving_name == 'undefined' ? null : data.saving_name,
      saving_no: typeof data.saving_no == 'undefined' ? null : data.saving_no,
      saving_type: typeof data.saving_type == 'undefined' ? null : data.saving_type,
      saving_branch_name:
        typeof data.saving_branch_name == 'undefined' ? null : data.saving_branch_name,
      saving_bank_name: typeof data.saving_bank_name == 'undefined' ? null : data.saving_bank_name,

      credit_card_name: typeof data.credit_card_name == 'undefined' ? null : data.credit_card_name,
      credit_card_no: typeof data.credit_card_no == 'undefined' ? null : data.credit_card_no,
      credit_card_type: typeof data.credit_card_type == 'undefined' ? null : data.credit_card_type,
      card_exp_month: typeof data.card_exp_month == 'undefined' ? null : data.card_exp_month,
      card_exp_year: typeof data.card_exp_year == 'undefined' ? null : data.card_exp_year,
      card_bank_name: typeof data.card_bank_name == 'undefined' ? null : data.card_bank_name,
    }
    let data_passport_id = null
    let data_card_id = null

    if (data.card_personal_type == 2) {
      if (dataRm.passport_id == null || dataRm.passport_id == '') {
        data_passport_id = data.card_id
        data_card_id = null
      } else {
        data_passport_id = dataRm.passport_id
        data_card_id = null
      }
    } else {
      if (dataRm.card_id == null || dataRm.card_id == '') {
        data_passport_id = null
        data_card_id = data.card_id
      } else {
        data_passport_id = null
        data_card_id = dataRm.card_id
      }
    }

    Vue.http
      .post(
        conf[env].VUE_APP_PATH_API + 'family-quotation/' + data.quotation_id,
        {
          customerInfo: {
            first_name: dataRm.first_name == null ? data.first_name : dataRm.first_name,
            last_name: dataRm.last_name == null ? data.last_name : dataRm.last_name,
            rm_id: dataRm.rm_id == null ? data.rm_id : dataRm.rm_id,
            card_id: data_card_id, //dataRm.card_id == null ? data.card_id : dataRm.card_id,
            passport_id: data_passport_id, //dataRm.passport_id == null ? data.passport_id : dataRm.passport_id,
            titleId: data.title_name.id,
            sex: dataRm.sex == null ? data.sex : dataRm.sex,
            birth_date: data.birthDay.human.origin,
            occupationId: data.occpation.id,
            card_address1: dataRm.card_address1,
            card_address2: dataRm.card_address2,
            card_address3: dataRm.card_address3,
            card_address4: dataRm.card_address4,
            card_city: dataRm.card_city,
            card_postcode: dataRm.card_postcode,
            card_country: dataRm.card_country,
            card_telephone: dataRm.card_telephone,
            card_mobile: dataRm.card_mobile,
            contact_address1: dataRm.contact_address1,
            contact_address2: dataRm.contact_address2,
            contact_address3: dataRm.contact_address3,
            contact_address4: dataRm.contact_address4,
            contact_city: dataRm.contact_city,
            contact_postcode: dataRm.contact_postcode,
            contact_country: dataRm.contact_country,
            contact_telephone: dataRm.contact_telephone,
            contact_mobile: dataRm.contact_mobile,
            email: data.email,
            height: data.height,
            weight: data.weight,
            isOldGeneraliClient: null,
            hasRm: dataRm.rm_id == null ? false : true,
            rm_result: dataRm.rm_id == null ? {} : dataRm,
            riskInfo: data.riskInfo,
            tviBlacklistResult: data.tviBlacklistResult,
          },
        },
        {
          headers: {
            Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
            'x-auth-from': this._vm.$session.get('chili').auth_from,
          },
        },
      )
      .then(
        response => {
          let res = response.body
          if (res.statusCode == 200) {
            let result = {
              quotationInfo: res.result.quotationInfo,
              dataRm: dataRm,
            }
            //console.log("success update qt fam" ,result)
            commit('UPDATE_QT_FAMILY', result)
            //this._vm.$swal.close();
          } else {
            //false
            //console.log("fail update qt fam")
            commit('UPDATE_QT_FAMILY', null)
          }
        },
        response => {
          let res = response.body
          if (res.statusCode == 401) {
            if (this._vm.$session.get('chili').auth_from == 'tmb') {
              var cookies = document.cookie.split(';')
              for (var i = 0; i < cookies.length; i++) {
                var equals = cookies[i].indexOf('=')
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
              }
              this._vm.$session.destroy()
              let url = conf[env].VUE_APP_TMB_LOGOUT_URL + conf[env].VUE_APP_LOCATION
              window.location.assign(url)
            } else {
              this._vm.$session.destroy()
              window.location.href = conf[env].VUE_APP_LOCATION
            }
          } else {
            commit('UPDATE_QT_FAMILY', null)
          }
        },
      )
  },
  api_get_family({ commit }, family_id) {
    Vue.http
      .get(conf[env].VUE_APP_PATH_API + 'family/' + family_id, {
        headers: {
          Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
          'x-auth-from': this._vm.$session.get('chili').auth_from,
        },
      })
      .then(
        response => {
          let res = response.body
          if (res.statusCode == 200) {
            //console.log("success get family" , res.result);
            commit('GET_FAMILY', res.result)
          } else {
            //console.log("false get family");
            commit('GET_FAMILY', null)
          }
        },
        response => {
          let res = response.body
          if (res.statusCode == 401) {
            if (this._vm.$session.get('chili').auth_from == 'tmb') {
              var cookies = document.cookie.split(';')
              for (var i = 0; i < cookies.length; i++) {
                var equals = cookies[i].indexOf('=')
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
              }
              this._vm.$session.destroy()
              let url = conf[env].VUE_APP_TMB_LOGOUT_URL + conf[env].VUE_APP_LOCATION
              window.location.assign(url)
            } else {
              this._vm.$session.destroy()
              window.location.href = conf[env].VUE_APP_LOCATION
            }
          } else {
            //console.log("error benefit");
            commit('GET_FAMILY', null)
          }
        },
      )
  },
  api_get_family_payer({ commit }, family_id) {
    Vue.http
      .get(conf[env].VUE_APP_PATH_API + 'family-payer/' + family_id, {
        headers: {
          Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
          'x-auth-from': this._vm.$session.get('chili').auth_from,
        },
      })
      .then(
        response => {
          let res = response.body
          if (res.statusCode == 200) {
            //console.log("success get family" , res.result);
            commit('GET_PAY_FAMILY', res.result)
          } else {
            //console.log("false get family");
            commit('GET_PAY_FAMILY', null)
          }
        },
        response => {
          let res = response.body
          if (res.statusCode == 401) {
            if (this._vm.$session.get('chili').auth_from == 'tmb') {
              var cookies = document.cookie.split(';')
              for (var i = 0; i < cookies.length; i++) {
                var equals = cookies[i].indexOf('=')
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
              }
              this._vm.$session.destroy()
              let url = conf[env].VUE_APP_TMB_LOGOUT_URL + conf[env].VUE_APP_LOCATION
              window.location.assign(url)
            } else {
              this._vm.$session.destroy()
              window.location.href = conf[env].VUE_APP_LOCATION
            }
          } else {
            //console.log("error benefit");
            commit('GET_PAY_FAMILY', null)
          }
        },
      )
  },
  api_update_family_qoutation_payer({ commit }, data) {
    Vue.http
      .post(
        conf[env].VUE_APP_PATH_API + 'family-quotation-payer/' + data.quotation_id,
        {
          quotationInfo: {
            payerId: data.payer_id,
            isCombinePayment: data.is_combine_payment,
          },
        },
        {
          headers: {
            Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
            'x-auth-from': this._vm.$session.get('chili').auth_from,
          },
        },
      )
      .then(
        response => {
          let res = response.body
          if (res.statusCode == 200) {
            //console.log("success family-quotation-payer" , res.result);
            let result = {
              quotationInfo: res.result.quotationInfo,
              payer: data,
            }
            commit('UPDATE_FAMILY_QT_PAYER', result)
          } else {
            //console.log("false family-quotation-payer");
            commit('UPDATE_FAMILY_QT_PAYER', null)
          }
        },
        response => {
          let res = response.body
          if (res.statusCode == 401) {
            if (this._vm.$session.get('chili').auth_from == 'tmb') {
              var cookies = document.cookie.split(';')
              for (var i = 0; i < cookies.length; i++) {
                var equals = cookies[i].indexOf('=')
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
              }
              this._vm.$session.destroy()
              let url = conf[env].VUE_APP_TMB_LOGOUT_URL + conf[env].VUE_APP_LOCATION
              window.location.assign(url)
            } else {
              this._vm.$session.destroy()
              window.location.href = conf[env].VUE_APP_LOCATION
            }
          } else {
            //console.log("error benefit");
            commit('UPDATE_FAMILY_QT_PAYER', null)
          }
        },
      )
  },
  api_update_family_main_payer({ commit }, data) {
    Vue.http
      .post(
        conf[env].VUE_APP_PATH_API + 'family-main-payer/' + data.family_id,
        {
          payerId: data.payer_id,
          isCombinePayment: data.is_combine_payment,
        },
        {
          headers: {
            Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
            'x-auth-from': this._vm.$session.get('chili').auth_from,
          },
        },
      )
      .then(
        response => {
          let res = response.body
          if (res.statusCode == 200) {
            //console.log("success family-main-payer" , res.result);
            commit('UPDATE_FAMILY_MAIN_PAYER', res.result)
          } else {
            //console.log("false family-main-payer");
            commit('UPDATE_FAMILY_MAIN_PAYER', null)
          }
        },
        response => {
          let res = response.body
          if (res.statusCode == 401) {
            if (this._vm.$session.get('chili').auth_from == 'tmb') {
              var cookies = document.cookie.split(';')
              for (var i = 0; i < cookies.length; i++) {
                var equals = cookies[i].indexOf('=')
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
              }
              this._vm.$session.destroy()
              let url = conf[env].VUE_APP_TMB_LOGOUT_URL + conf[env].VUE_APP_LOCATION
              window.location.assign(url)
            } else {
              this._vm.$session.destroy()
              window.location.href = conf[env].VUE_APP_LOCATION
            }
          } else {
            //console.log("error benefit");
            commit('UPDATE_FAMILY_MAIN_PAYER', null)
          }
        },
      )
  },
  fetchIsOffsideSaleFamilyQuotationById: async function ({ commit }, familyId) {
    const { FAMILY: { GET_IS_OFFSIDE_SALE_BY_ID } } = API
    const headers = { ...generateAuthorizationRequestHeader() }
    const url = GET_IS_OFFSIDE_SALE_BY_ID(familyId)

    const response = await Vue.http.get(url, { headers })
    const { statusCode, result: { isOffsideSale } } = await response.json()

    if (_.eq(statusCode, 200)) {
      commit('IS_OFFSIDE_SALE_FAMILY_QUOTATION', isOffsideSale)
    }
  },
  updateOffsideSaleFamilyQuotationById: async function({ commit }, payload) {
    const { familyId, isOffsideSale } = payload
    const { FAMILY: { PUT_IS_OFFSIDE_SALE_BY_ID } } = API
    const headers = { ...generateAuthorizationRequestHeader() }
    const url = PUT_IS_OFFSIDE_SALE_BY_ID(familyId)
    const data = { isOffsideSale }

    const response = await Vue.http.put(url, data, { headers })
    const { statusCode, result } = await response.json()

    if (_.eq(statusCode, 200)) {
      const { message } = result
      console.info(message)
    }
  }
}

const getters = {
  getFamilyFields,
  familyInformation: state => state.familyInformation,
  familyRelationship: state => state.familyRelationship,
  beneficiaryRelationship: state => state.beneficiaryRelationship,
  validationRules: state => state.rules,

  resGetListPayer: state => state.list_payer,
  resCreatefamily: state => state.create_family,
  resUpdateQtfamily: state => state.update_qt_family,
  resUpdateRelation: state => state.update_relation,
  resGetfamily: state => state.get_family,
  resUpdateFamilyPayer: state => state.update_family_payer,
  resUpdateFamilyMainPayer: state => state.update_family_main_payer,
  getCheckRelations: state => state.select_relation,
  getCheckPeymentFamily: state => state.check_payment_family,
  checkDiscout5percent: state => data => {
    //console.log('this.resGetQuotation 5 fam' ,data)
    //console.log('member',data.list_family.length)
    let child = 0
    let adult = 0
    if (data.list_family.length == 3) {
      //console.log('case:5% ,==3')
      if (data.age < 16) {
        child += 1
      }
      if (data.age >= 16) {
        adult += 1
      }
      data.list_family.forEach(function(element) {
        //console.log(element.age)
        if (element.age < 16 && element.age != null) {
          child += 1
        }
        if (element.age >= 16 && element.age != null) {
          adult += 1
        }
      })
      //console.log('discount chdk 10', child)
      if (child > 2 || adult > 1) {
        return false
      } else {
        return true
      }
    } else {
      //console.log('case:5% ,==2')
      //check member 2
      if (data.age < 16) {
        child += 1
      }
      if (data.age >= 16) {
        adult += 1
      }
      data.list_family.forEach(function(element) {
        //console.log(element.age)
        if (element.age < 16 && element.age != null) {
          child += 1
        }
        if (element.age >= 16 && element.age != null) {
          adult += 1
        }
      })
      if (child > 1 || adult > 2) {
        return false
      } else {
        return true
      }
    }
  },
  checkDiscout10percent: state => data => {
    //console.log('this.resGetQuotation 10 fam' ,data)
    //console.log('member',data.list_family.length)
    let child = 0
    let adult = 0
    if (data.list_family.length > 3) {
      //console.log('case:10% ,>3')
      if (data.age < 16) {
        child += 1
      }
      if (data.age >= 16) {
        adult += 1
      }
      data.list_family.forEach(function(element) {
        //console.log(element.age)
        if (element.age < 16 && element.age != null) {
          child += 1
        }
        if (element.age >= 16 && element.age != null) {
          adult += 1
        }
      })
      if (child > 2) {
        return false
      } else {
        return true
      }
    } else {
      //console.log('case:10% ,3')
      if (data.age < 16) {
        child += 1
      }
      if (data.age >= 16) {
        adult += 1
      }
      data.list_family.forEach(function(element) {
        if (element.age < 16 && element.age != null) {
          child += 1
        }
        if (element.age >= 16 && element.age != null) {
          adult += 1
        }
      })
      if (child > 1) {
        return false
      } else {
        return true
      }
    }
  },
  checkSelectExtra: state => data => {
    //console.log('EXtra',data)
    let check = true
    if (data.age < 16) {
      data.list_family.forEach(function(element) {
        if (element.age >= 16 && element.age != null) {
          if (element.planId == 'P002') {
            check = false
          }
        }
      })
    } else {
      check = false
    }
    return check
  },
  isOffsideSaleFamilyQuotation: state => state.isOffsideSaleFamilyQuotation
}

export default {
  state,
  getters,
  mutations,
  actions,
}
